import React from "react";
import Letop from "../allpages/Letop";

export default () => (
  <div>
    <div className="table">
      <table>
        <tr>
          <th className="col" />
          <th colSpan={3}>longus</th>
        </tr>
        <tr>
          <th className="col bor-bot" />
          <th>mannelijk</th>
          <th>vrouwelijk</th>
          <th>onzijdig</th>
        </tr>
        <tr>
          <th className="col">nom. ev.</th>
          <td>
            long–
            <strong>us</strong>
          </td>
          <td>
            long–
            <strong>a</strong>
          </td>
          <td>
            long–
            <strong>um</strong>
          </td>
        </tr>
        <tr>
          <th className="col">gen. ev.</th>
          <td>
            long–
            <strong>i</strong>
          </td>
          <td>
            long–
            <strong>ae</strong>
          </td>
          <td>
            long–
            <strong>i</strong>
          </td>
        </tr>
        <tr>
          <th className="col">dat. ev.</th>
          <td>
            long–
            <strong>o</strong>
          </td>
          <td>
            long–
            <strong>ae</strong>
          </td>
          <td>
            long–
            <strong>o</strong>
          </td>
        </tr>
        <tr>
          <th className="col">acc. ev.</th>
          <td>
            long–
            <strong>um</strong>
          </td>
          <td>
            long–
            <strong>am</strong>
          </td>
          <td>
            long–
            <strong>um</strong>
          </td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. ev.</th>
          <td className="bor-bot">
            long–
            <strong>o</strong>
          </td>
          <td className="bor-bot">
            long–
            <strong>a</strong>
          </td>
          <td className="bor-bot">
            long–
            <strong>o</strong>
          </td>
        </tr>
        <tr>
          <th className="col">nom. mv.</th>
          <td>
            long–
            <strong>i</strong>
          </td>
          <td>
            long–
            <strong>ae</strong>
          </td>
          <td>
            long–
            <strong>a</strong>
          </td>
        </tr>
        <tr>
          <th className="col">gen. mv.</th>
          <td>
            long–
            <strong>orum</strong>
          </td>
          <td>
            long–
            <strong>arum</strong>
          </td>
          <td>
            long–
            <strong>orum</strong>
          </td>
        </tr>
        <tr>
          <th className="col">dat. mv.</th>
          <td>
            long–
            <strong>is</strong>
          </td>
          <td>
            long–
            <strong>is</strong>
          </td>
          <td>
            long–
            <strong>is</strong>
          </td>
        </tr>
        <tr>
          <th className="col">acc. mv.</th>
          <td>
            long–
            <strong>os</strong>
          </td>
          <td>
            long–
            <strong>as</strong>
          </td>
          <td>
            long–
            <strong>a</strong>
          </td>
        </tr>
        <tr>
          <th className="col">abl. mv.</th>
          <td>
            long–
            <strong>is</strong>
          </td>
          <td>
            long–
            <strong>is</strong>
          </td>
          <td>
            long–
            <strong>is</strong>
          </td>
        </tr>
      </table>
    </div>

    <p>
      <Letop>
        Het rijtje van <strong>longus</strong> gaat in feite hetzelfde als de
        rijtjes van{" "}
        <a href="zelfstandig-naamwoord">
          <strong>servus</strong>, <strong>femina</strong> en{" "}
          <strong>donum</strong>
        </a>
        .
      </Letop>
    </p>

    <div className="table">
      <table>
        <tr>
          <th className="col" />
          <th colSpan={2}>fortis</th>
          <th colSpan={2}>ingens</th>
        </tr>
        <tr>
          <th className="col bor-bot" />
          <th>mnl/vrl</th>
          <th>onzijdig</th>
          <th>mnl/vrl</th>
          <th>onzijdig</th>
        </tr>
        <tr>
          <th className="col">nom. ev.</th>
          <td>
            fortis
          </td>
          <td>
            fort–
            <strong>e</strong>
          </td>
          <td>
            ingens
            <strong />
          </td>
          <td>
            ingens
            <strong />
          </td>
        </tr>
        <tr>
          <th className="col">gen. ev.</th>
          <td>
            fort–
            <strong>is</strong>
          </td>
          <td>
            fort–
            <strong>is</strong>
          </td>
          <td>
            ingent–
            <strong>is</strong>
          </td>
          <td>
            ingent–
            <strong>is</strong>
          </td>
        </tr>
        <tr>
          <th className="col">dat. ev.</th>
          <td>
            fort–
            <strong>i</strong>
          </td>
          <td>
            fort–
            <strong>i</strong>
          </td>
          <td>
            ingent–
            <strong>i</strong>
          </td>
          <td>
            ingent–
            <strong>i</strong>
          </td>
        </tr>
        <tr>
          <th className="col">acc. ev.</th>
          <td>
            fort–
            <strong>em</strong>
          </td>
          <td>
            fort–
            <strong>e</strong>
          </td>
          <td>
            ingent–
            <strong>em</strong>
          </td>
          <td>
            ingens
            <strong />
          </td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. ev.</th>
          <td className="bor-bot">
            fort–
            <strong>i</strong>
          </td>
          <td className="bor-bot">
            fort–
            <strong>i</strong>
          </td>
          <td className="bor-bot">
            ingent–
            <strong>i</strong>
          </td>
          <td className="bor-bot">
            ingent–
            <strong>i</strong>
          </td>
        </tr>
        <tr>
          <th className="col">nom. mv.</th>
          <td>
            fort–
            <strong>es</strong>
          </td>
          <td>
            fort–
            <strong>ia</strong>
          </td>
          <td>
            ingent–
            <strong>es</strong>
          </td>
          <td>
            ingent–
            <strong>ia</strong>
          </td>
        </tr>
        <tr>
          <th className="col">gen. mv.</th>
          <td>
            fort–
            <strong>ium</strong>
          </td>
          <td>
            fort–
            <strong>ium</strong>
          </td>
          <td>
            ingent–
            <strong>ium</strong>
          </td>
          <td>
            ingent–
            <strong>ium</strong>
          </td>
        </tr>
        <tr>
          <th className="col">dat. mv.</th>
          <td>
            fort–
            <strong>ibus</strong>
          </td>
          <td>
            fort–
            <strong>ibus</strong>
          </td>
          <td>
            ingent–
            <strong>ibus</strong>
          </td>
          <td>
            ingent–
            <strong>ibus</strong>
          </td>
        </tr>
        <tr>
          <th className="col">acc. mv.</th>
          <td>
            fort–
            <strong>es</strong>
          </td>
          <td>
            fort–
            <strong>ia</strong>
          </td>
          <td>
            ingent–
            <strong>es</strong>
          </td>
          <td>
            ingent–
            <strong>ia</strong>
          </td>
        </tr>
        <tr>
          <th className="col">abl. mv.</th>
          <td>
            fort–
            <strong>ibus</strong>
          </td>
          <td>
            fort–
            <strong>ibus</strong>
          </td>
          <td>
            ingent–
            <strong>ibus</strong>
          </td>
          <td>
            ingent–
            <strong>ibus</strong>
          </td>
        </tr>
      </table>
    </div>

    <p>
      <Letop>
        De rijtjes van <strong>fortis</strong> en <strong>ingens</strong> gaan
        grotendeels hetzelfde als de rijtjes van{" "}
        <a href="zelfstandig-naamwoord">
          <strong>rex</strong> en <strong>nomen</strong>
        </a>
        .
      </Letop>
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/tables/bnw-16.js